<template>
  <div class="app-container">
    <div class="tabs">
      <div v-for="(tab, index) in tabs" :key="index" class="tab" :class="{ active: activeTab === index }"
        @click="setActiveTab(index)">
        {{ tab.title }}
      </div>
    </div>
    <div style="flex: 1;overflow: auto;">
      <real-question v-if="activeTab === 0" type="puji"></real-question>
      <real-question v-else-if="activeTab === 1" type="tigao"></real-question>
      <real-question v-else-if="activeTab === 2" type="noip"></real-question>
      <algorithm v-else></algorithm>
    </div>
  </div>
</template>

<script>
import Algorithm from "./components/algorithm";
import RealQuestion from "./components/realQuestion";
export default {
  name: "statistics",
  components: {
    'algorithm': Algorithm,
    'real-question': RealQuestion,
  },
  data() {
    return {
      activeTab: 0,
      tabs: [
        { title: '普及组真题', component: 'real-question', type: 'puji' },
        { title: '提高组真题', component: 'real-question', type: 'tigao' },
        { title: 'NOIP真题', component: 'real-question', type: 'noip' },
        { title: '算法知识点统计', component: 'algorithm' },
      ],
    }
  },
  computed: {},
  watch: {
    '$route.query.activeTab': {  // 监听路由查询参数 activeTab
      immediate: true,           // 立即执行一次
      handler(newTab) {          // 变化时的处理函数
        if (newTab) {
          this.activeTab = parseInt(newTab) // 根据路由参数设置激活的tab
        }
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    setActiveTab(index) {
      this.activeTab = index;
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  height: calc(100% - 1.6rem);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .tabs {
    display: flex;

    .tab {
      font-size: 1.12rem;
      padding: 0.6rem 2rem;
      margin-right: -1rem;
      clip-path: polygon(10% 0%, 90% 0%, 100% 100%, 0% 100%);
      background-color: #234458;
      color: white;
      cursor: pointer;
      position: relative;
      z-index: 1;
      transition: background-color 0.3s;
      border-radius: 0.25rem;

      &.active {
        background-color: #04CFCF;
        z-index: 2;
      }

      &:hover {
        background-color: #03B9B9;
      }
    }
  }

}
</style>
